import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSuperblockSelection, getSuperblockSelections, getSuperblockSelectionData, updateSuperblockQuotation } from 'src/_helpers/api';

const name = 'superblockSelections';

const initialState = {
  superblockSelections: [],
  superblockSelectionFormData :[],
  error: null,
};

const addSuperblockSelectionAsync = createAsyncThunk(`${name}/add-superblock-selection`, async (selectionData, { rejectWithValue }) => {
  try {
    const response = await createSuperblockSelection(selectionData);
    //console.log('🚀 ~ API response received:', response);
    return response;
  } catch (error) {
    //console.error('🚀 ~ Error occurred in addSelectionAsync:', error);
    return rejectWithValue(error.response ? error.response.data : 'Unknown error');
  }
});

const getSuperblockSelectionsAsync = createAsyncThunk(
  `${name}/get-superblock-selections`,
  async (userInfo) => {
    return await getSuperblockSelections(userInfo)
  },
)

const getSuperblockSelectionDataAsync = createAsyncThunk(
  `${name}/get-superblock-selectionData`,
  async (selectionImportCode) => {
    return await getSuperblockSelectionData(selectionImportCode)
  },
)

// const updateSuperblockSubmittalAsync = createAsyncThunk(`${name}/update-superblock-submittal`, async (submittalData) => {
// //console.log('🚀 ~ submittalData:', submittalData)
//   return await updateSuperblockQuotation(submittalData)
// })

const superblockSelectionSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.superblockSelections = [];
      state.superblockSelectionFormData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addSuperblockSelectionAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addSuperblockSelectionAsync.fulfilled, (state, action) => {
        state.superblockSelections.push(action.payload);
      })
      .addCase(addSuperblockSelectionAsync.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(getSuperblockSelectionsAsync.pending, (state) => {
        state.error = null
      })
      .addCase(getSuperblockSelectionsAsync.fulfilled, (state, action) => {
        state.superblockSelections = action.payload.data
      })
      .addCase(getSuperblockSelectionsAsync.rejected, (state, action) => {
        state.error = action.error
      })
      .addCase(getSuperblockSelectionDataAsync.pending, (state) => {
        state.error = null
      })
      .addCase(getSuperblockSelectionDataAsync.fulfilled, (state, action) => {
        state.superblockSelectionFormData = action.payload.data
      })
      .addCase(getSuperblockSelectionDataAsync.rejected, (state, action) => {
        state.error = action.error
      })
    //   .addCase(updateSuperblockSelectionAsync.pending, (state) => {
    //     state.error = null;
    //   })
    //   .addCase(updateSuperblockSelectionAsync.fulfilled, (state, action) => {
    //     const index = state.superblockSelections.findIndex(s => s.id === action.payload.id);
    //     if (index !== -1) state.superblockSelections[index] = action.payload;
    //   })
    //   .addCase(updateSuperblockSelectionAsync.rejected, (state, action) => {
    //     state.error = action.error;
    //   });
  },
});

export const superblockSelectionActions = {
  ...superblockSelectionSlice.actions,
  addSuperblockSelectionAsync,
  getSuperblockSelectionsAsync,
 // updateSuperblockSelectionAsync,
  getSuperblockSelectionDataAsync,
};

export const superblockSelectionsReducer = superblockSelectionSlice.reducer;
